import React from 'react';
import { CollapsablePanel } from './CollapsablePanel';
import { RydMixer } from '../../audio/mixer';
import { RydAudioMixer } from '../audio/RydAudioMixer';
import { TrackColor } from '../../render/trackColor';
import {
    useWorkspaceInstrumentAssignments,
    useWorkspaceUIState
} from '../../stores/WorkspaceStore';
import { useMixerStore } from '../../stores/MixerStore';


export function RydMixerPanel({
    onUpdate,
    onUpdateMaster,
    isCollapsed,
    toggleCollapse
}: {
    onUpdate: (id: number, changes: Partial<RydMixer.TrackParams>) => void,
    onUpdateMaster: (changes: Partial<RydMixer.TrackParams>) => void,
    isCollapsed: boolean,
    toggleCollapse: () => void,
}) {

    const workspaceUiState = useWorkspaceUIState();
    const mixerState = useMixerStore();
    const instrumentAssignments = useWorkspaceInstrumentAssignments();

    if (!mixerState.mixer) return <div>Loading mixer...</div>;

    const tracks = Array.from(mixerState.mixer.tracks.keys())
        // FIXME: sort in the order of the track ids in the project which SHOULD (nothing else being brokend)
        // be the same as the order in project.lines. This is brittle. We should store the order explicitly.
        .sort((a, b) => a - b)
        .map(i => {
            const t = mixerState.mixer?.tracks.get(i)!;
            return {
                ...t.params,
                trackColor: workspaceUiState.tracks.get(i)?.color || TrackColor.DEFAULT_COLOR,
                output: instrumentAssignments.get(i)
            };
        }) || [];

    return (
        <CollapsablePanel
        isCollapsed={isCollapsed}
        toggleCollapse={toggleCollapse}
        orientation='bottom'>
            <RydAudioMixer
            tracks={tracks}
            onUpdate={onUpdate}
            onUpdateMaster={onUpdateMaster}
            />
        </CollapsablePanel>
    );

}